import { Component, OnInit } from '@angular/core';
import { MenuItem } from '../../../models/menu/menu-item.class';
import { RedireccionService } from '../../../services/redireccion/redireccion.service';
import { DialogService } from '../../../services/dialog/dialog.service';
import { MensajeSnackBarService } from '../../../services/mensaje-snack-bar/mensaje-snack-bar.service';
import { UtilService } from '../../../services/util/util.service';
import { ConsultaClienteDialogComponent } from '../../cliente/dialogs/consulta-cliente-dialog/consulta-cliente-dialog.component';
import * as msg from '../../../../assets/msg/message.json';
import { RedireccionMenu } from '../../../models/menu/redireccion-menu.class';
import { AgenteIdoneo } from '../../../models/agente/agente-idoneo.class';
import { MensajeInformativoDialogComponent } from '../../shared/dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component';
import { MenuConstant } from '../../../contants/menu.constant';

@Component({
  selector: 'app-master-menu',
  templateUrl: './master-menu.component.html',
})
export class MasterMenuComponent {
  constructor(
    public redireccionService: RedireccionService,
    public dialogService: DialogService,
    public mensajeSnackBarService: MensajeSnackBarService,
    public utilService: UtilService
  ) {}

  async ejecutarOpcionSeleccionada(menuItem: MenuItem) {
    if (menuItem !== null) {
      if (
        this.utilService.validateUndefinedNull(menuItem.isStatic) &&
        menuItem.isStatic
      ) {
        this.ejecutarRedireccion(menuItem);
      } else if (
        this.utilService.validateUndefinedNull(menuItem.detalleOpcion)
      ) {
        const agenteIdoneo: AgenteIdoneo =
          await this.redireccionService.validarIdoneidad(
            menuItem.detalleOpcion
          );
        if (
          this.utilService.validateUndefinedNull(agenteIdoneo) &&
          agenteIdoneo.idoneo
        ) {
          this.ejecutarRedireccion(menuItem);
        } else {
          this.dialogService.open(MensajeInformativoDialogComponent, {
            mensaje:
              this.utilService.validateUndefinedNull(agenteIdoneo) &&
              this.utilService.validateUndefinedNull(agenteIdoneo.mensajeError)
                ? agenteIdoneo.mensajeError
                : (<any>msg).msgMenu.ideoneidaNegativa,
          });
        }
      } else {
        this.ejecutarRedireccion(menuItem);
      }
    }
  }

  ejecutarRedireccion(menuItem: MenuItem) {

    if (menuItem.redireccionMenu == null) {
      const asd = 'Selección no válida: menú no cargado.';

      this.dialogService.open(MensajeInformativoDialogComponent, {
        mensaje: asd + ' Intente recargar la página.'
      });

      return;
    }


    const consultarCliente = this.redireccionService.optionMenuConsultaCliente(
      menuItem.redireccionMenu.opcionVenta
    );
    if (consultarCliente) {
      this.dialogService.open(ConsultaClienteDialogComponent, menuItem);
    } else if (menuItem.redireccionMenu.codigoProducto === MenuConstant.REDIRECCION_MENU_MODIFICACIONES_PVP) {
      this.dialogService.open(MensajeInformativoDialogComponent, {
        mensaje: MenuConstant.MENSAJE_MODIFICACIONES_PVP,
        funcionAceptar: () => {
          this.redireccionService.ejecutarRedireccion(menuItem.redireccionMenu);
        },
        funcionCancelar: () => {}
      });
    } else {
      this.redireccionService.ejecutarRedireccion(menuItem.redireccionMenu);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu/master-menu/master-menu.component.ts